import React from "react";
import { AuthContext } from "../../../lib/AuthContext";
import ParentComponent from "../../../lib/ParentComponent";
import firebase, { auth } from "../../../lib/firebase";
import Utils from "../../../Utils";
import { NavLink } from "react-router-dom";
import ar from "../../../locale";
import { deleteUrl } from "../../../constants";

export default class FeminineVideos extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      videos: [],
      token: null,
      deleting: {},
    };
    this.videosRef = firebase.database().ref("videos/");
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    this.videosRef.on("value", (response) => {
      this.state.videos = Utils.convertToArrayWithInsertionOrder(
        response.val()
      );
      this.updateState();
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.videosRef.off("value");
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  renderVideos = (video) => {
    return (
      <tr key={video.key}>
        <td>
          {video.poster && (
            <img
              src={video.poster}
              alt="avatar"
              className="avatarc"
              width="30"
              height="30"
            />
          )}
        </td>
        <td className="title">
          <NavLink to={"/feminine/videos/" + video.key}>{video.title}</NavLink>
        </td>
        <td>{video.likes}</td>
        <td>{video.shares}</td>
        <td>
          {!this.state.deleting[video.key] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteConfirmation.bind(this, video)}
            ></i>
          )}
          {this.state.deleting[video.key] && (
            <div
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></div>
          )}
        </td>
      </tr>
    );
  };

  deleteConfirmation = (item) => {
    this.confirm(null, this.deleteVideo.bind(this, item));
  };

  deleteVideo = (video) => {
    this.state.deleting[video.key] = true;
    this.updateState();
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      body: JSON.stringify({
        path: "videos/" + video.key,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.updateState();
      })
      .catch((error) => {
        this.state.deleting[video.key] = false;
        this.showError(error.message);
      });
  };

  render() {
    let { videos } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-right">
            <NavLink
              to="/feminine/videos/add"
              className="btn btn-info btn-rounded"
            >
              {ar.add_new}
            </NavLink>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <table
              id="sawtable"
              className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
              data-tablesaw-mode="stack"
              data-tablesaw-sortable
            >
              <thead>
                <tr>
                  <th scope="col" data-tablesaw-priority="2" className="border">
                    &nbsp;
                  </th>
                  <th
                    scope="col"
                    data-tablesaw-sortable-col
                    data-tablesaw-priority="3"
                    className="border"
                  >
                    {ar.title}
                  </th>
                  <th
                    scope="col"
                    data-tablesaw-sortable-col
                    data-tablesaw-priority="2"
                    className="border"
                  >
                    {ar.likes}
                  </th>
                  <th
                    scope="col"
                    data-tablesaw-sortable-col
                    data-tablesaw-priority="2"
                    className="border"
                  >
                    {ar.share}
                  </th>
                  <th scope="col" className="border">
                    {ar.delete}
                  </th>
                </tr>
              </thead>
              <tbody>
                {videos.map((video, index) => this.renderVideos(video))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
